import type { Radio, StationRow } from '../../audio/radio/radio';
import { el } from '../components/el';

/** The drop-down list of stations under the radio bar. Tap a row to tune to it. */
export class RadioList {
  readonly root = el('div', 'radio-list');
  private open = false;

  constructor(private readonly radio: Radio, private readonly onPicked: () => void) {
    this.root.hidden = true;
  }

  get isOpen(): boolean {
    return this.open;
  }

  async toggle(): Promise<void> {
    if (this.open) return this.close();
    this.open = true;
    this.root.hidden = false;
    this.root.replaceChildren(el('p', 'radio-list-note', 'Finding stations…'));
    const rows = await this.radio.stationList();
    if (!this.open) return;
    this.render(rows);
  }

  close(): void {
    this.open = false;
    this.root.hidden = true;
  }

  private render(rows: StationRow[]): void {
    this.root.replaceChildren();
    let group = '';
    for (const row of rows) {
      const heading = row.badge === 'MIX' ? 'Built-in stations' : 'Live Ghana FM';
      if (heading !== group) {
        group = heading;
        this.root.append(el('p', 'radio-list-head', heading));
      }
      this.root.append(this.button(row));
    }
    this.root.querySelector('.current')?.scrollIntoView({ block: 'nearest' });
  }

  private button(row: StationRow): HTMLButtonElement {
    const button = el('button', row.current ? 'radio-row current' : 'radio-row');
    const name = el('span', 'radio-row-name', row.name);
    const detail = el('small', 'radio-row-detail', row.detail);
    button.append(el('b', 'radio-badge', row.badge), name, detail);
    button.addEventListener('click', () => {
      void this.radio.tuneTo(row.index);
      this.onPicked();
    });
    return button;
  }
}
